import { isMaybeIncognitoComet } from '#pplx/frontend/apps/ask/comet-shared/cometUtils.js';
import { useBrowserAgentDisabledByOrg } from '#pplx/frontend/apps/ask/organization/hooks/useBrowserAgentDisabledByOrg.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { isCometOffTheRecordProfile } from '#pplx/frontend/comet/client/utils.js';
export function useBrowserAgentSearchModeEnabled() {
    const isDisabledByOrg = useBrowserAgentDisabledByOrg();
    const { session } = useSession();
    const isAvailable = isMaybeIncognitoComet();
    const isDisabledByIncognito = isCometOffTheRecordProfile();
    // We intentionally check payment_tier === 'free' rather than using useIsSubscribed
    // because we want to hide the model selector for both free users AND non-paying Pro users
    // (e.g., users with gifted Pro). Only users who are actively paying (CC Pro) should see the selector.
    const isFreeUser = session?.user?.payment_tier === 'free';
    return {
        isAvailable,
        isDisabledByOrg,
        isDisabledByIncognito,
        shouldShowModelSelector: isAvailable && !isDisabledByIncognito && !isFreeUser,
    };
}
//# sourceMappingURL=useBrowserAgentSearchModeEnabled.js.map